import InnerComponent from '@Components/Purchase/GoodsReceiving/GRNForm';
import orgContainer from '@Components/AppContainer';

const GRNForm = () => ((orgContainer(InnerComponent)));
export default GRNForm;
